import "@janeapp/burrito-design-system/fonts.css"
import "@janeapp/burrito-design-system/globalTheme"
import { BurritoProvider, Toaster } from "@janeapp/burrito-design-system"
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { kcActionResult } from './helpers/kcActionResult'
import './index.css'
import reportWebVitals from './reportWebVitals'

// Read Keycloak's kc_action_status from the callback URL before react-oidc
// processes it, so a completed action can be surfaced as a toast on the hub.
kcActionResult().capture(window.location.search)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BurritoProvider>
      <App />
      <Toaster />
    </BurritoProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
